export default {
  row: {},
  bank: {},
  active: 0,
  shopRow: {},
  userInfo: {},
  systemInfo: {},
  payInfo: {
    password: ''
  },
  selectFreightModels: {},
  problemInfo: {},
  noticeInfo: {},
  keepAliveList: []
}
